import { Component, EventEmitter, OnDestroy, OnInit, Output } from "@angular/core";
import { SystemNotification } from "ng/src/app/notifications/notification.model";
import { SystemNotificationService } from "ng/src/app/notifications/system-notification.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { PrimeIcons } from "primeng/api";

@Component({
	selector: 'system-notification-list',
	template: `
		<p-table [value]="notifications"
		         selectionMode="single"
		         [rowHover]="true"
		         [(selection)]="selectedNotification"
		         dataKey="id">
			<ng-template pTemplate="body" let-notification>
				<tr [pSelectableRow]="notification">
					<td style="width: 2em">
						<i *ngIf="getNotificationIsUnread(notification)" [class]="Icons.BELL"></i>
					</td>
					<td>
						<div class="p-d-flex p-flex-column">
							<h5 class="subject p-m-0">{{notification.title}}</h5>
							<div class="p-d-flex p-jc-between p-ai-center">
								<span>LogBook</span>
								<span>{{notification.created | date: 'MM/dd/yyyy HH:mm'}}</span>
							</div>
						</div>
					</td>
				</tr>
			</ng-template>
		</p-table>
	`,
	styles: [
		'tr > td { padding: 0.5rem }',
		'h5.subject { font-size: 1.143rem }'
	]
})
export class SystemNotificationListComponent implements OnInit, OnDestroy {
	
	@Output()
	onNotificationSelected = new EventEmitter<SystemNotification>();
	
	notifications: SystemNotification[] = [];
	
	private _selected?: SystemNotification;
	private readonly destroySubject = new Subject();
	readonly onDestroy$ = this.destroySubject.asObservable();
	
	readonly Icons = PrimeIcons;
	
	get selectedNotification() {
		return this._selected;
	}
	
	set selectedNotification(val: SystemNotification | undefined) {
		if (val === this._selected) return;
		
		if (val) {
			this.onNotificationSelected.emit(val);
		}
		
		this._selected = val;
		
	}
	
	constructor(
		private systemNotificationService: SystemNotificationService
	) {}
	
	ngOnInit(): void {
		this.systemNotificationService.getPoll().pipe(
			takeUntil(this.onDestroy$)
		)
			.subscribe((res) => {
				if (Array.isArray(res)) {
					this.notifications = res;
				}
			})
	}
	
	ngOnDestroy(): void {
		this.destroySubject.next();
	}
	
	getNotificationIsUnread(notification: SystemNotification) {
		const lastDate = this.systemNotificationService.getLastViewedTimestamp();
		return lastDate ? lastDate < new Date(notification.created) : true;
	}
}